import React, { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'
import SiteHeader from './components/Layout/SiteHeader'
import Footer from './components/Layout/Footer'
import 'semantic-ui-style/semantic.min.css'
import './App.css'

import Home from './pages/home'
import About from './pages/about'
import Services from './pages/services'
// import ServiceAreas from './pages/service-areas'
import WhyUs from './pages/why-us'
import Contact from './pages/contact'
import NotFound from './pages/404'
import PrivacyPolicy from './pages/privacy-policy'
import ScrollToTop from './components/ScrollToTop'

export default function App() {
  const menuItems = [
    {
      name: 'Our Services',
      path: 'services'
    },
    {
      name: 'About',
      path: 'about'
    },
    {
      name: 'Why Us',
      path: 'why-choose-clark-tree-services'
    },
    {
      name: 'Contact',
      path: 'contact'
    }
    // {
    //   name: 'Service Areas',
    //   path: 'service-areas'
    // }
  ]
  return (
    <div className="App">
      <ScrollToTop />
      <div className="greenTop"></div>
      <SiteHeader menuItems={menuItems} />

      <div className="content-wrapper">
        {/* <Container> */}
        <Suspense fallback={<div className="ui active centered loader"></div>}>
          <Routes>
            <Route path={`/`} element={<Home />} />
            <Route exact path={'/about'} element={<About />} />
            <Route exact path={'/services'} element={<Services />} />
            <Route
              exact
              path={'/why-choose-clark-tree-services'}
              element={<WhyUs />}
            />
            {/* <Route exact path={'/service-areas'} element={<ServiceAreas />} /> */}
            <Route exact path={'/contact'} element={<Contact />} />
            <Route exact path={'/privacy-policy'} element={<PrivacyPolicy />} />
            <Route path={`/*`} element={<NotFound />} />
          </Routes>
        </Suspense>
        {/* </Container> */}
      </div>

      <Footer />
    </div>
  )
}
